import React, { useState } from "react";
import { useSlateStatic, useSelected, useFocused, ReactEditor } from "slate-react";
import { Transforms } from "slate";
import { Button, Popover, Space } from "antd";
import {
  DeleteOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined
} from "@ant-design/icons";

const EmbedElement = ({ attributes, element, children }) => {
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);
  const selected = useSelected();
  const focused = useFocused();
  const [hovered, setHovered] = useState(false);
  const [width, setWidth] = useState(element.width || 500);
  const [height, setHeight] = useState(element.height || 280);

  const deleteVideo = () => {
    Transforms.removeNodes(editor, { at: path });
  };

  const setAlignment = (align) => {
    Transforms.setNodes(editor, { align }, { at: path });
  };

  const popoverContent = (
    <Space>
      <Button size="small" icon={<AlignLeftOutlined />} onMouseDown={(e) => { e.preventDefault(); setAlignment("left"); }} />
      <Button size="small" icon={<AlignCenterOutlined />} onMouseDown={(e) => { e.preventDefault(); setAlignment("center"); }} />
      <Button size="small" icon={<AlignRightOutlined />} onMouseDown={(e) => { e.preventDefault(); setAlignment("right"); }} />
      <Button size="small" danger icon={<DeleteOutlined />} onMouseDown={(e) => { e.preventDefault(); deleteVideo(); }} />
    </Space>
  );

  return (
    <div
      {...attributes}
      contentEditable={false}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        textAlign: element.align || "center",
        margin: "1rem 0",
        position: "relative"
      }}
    >
      <Popover
        content={popoverContent}
        placement="top"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
      >
        <div
          style={{
            display: "inline-block",
            position: "relative",
            width: `${width}px`,
            border: selected && focused ? "2px solid #1677ff" : "none",
            borderRadius: "8px"
          }}
        >
          <iframe
            src={element.url}
            title="Embedded video"
            frameBorder="0"
            allowFullScreen
            width={width}
            height={height}
            style={{ borderRadius: "8px", display: "block" }}
          />

          {/* Resize Handler */}
          {hovered && (
            <div
              style={{
                position: "absolute",
                right: "-8px",
                bottom: "-8px",
                width: "16px",
                height: "16px",
                backgroundColor: "#1677ff",
                cursor: "nwse-resize",
                borderRadius: "50%"
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                const startX = e.clientX;
                const startWidth = width;

                const handleMouseMove = (moveEvent) => {
                  const delta = moveEvent.clientX - startX;
                  const newWidth = Math.max(200, startWidth + delta);
                  const newHeight = (newWidth / 16) * 9; // Keep 16:9 ratio
                  setWidth(newWidth);
                  setHeight(newHeight);
                  Transforms.setNodes(editor, { width: newWidth, height: newHeight }, { at: path });
                };

                const handleMouseUp = () => {
                  document.removeEventListener("mousemove", handleMouseMove);
                  document.removeEventListener("mouseup", handleMouseUp);
                };

                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
              }}
            />
          )}
        </div>
      </Popover>

      {children}
    </div>
  );
};

export default EmbedElement;
